import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const staffAllowedRoutes = [
  "/video",
  "/ecommerce-products",
  "/ecommerce-categories",
  "/ecommerce-customers",
  "/ecommerce-add-product",
  "/user-details/:id",
  "/ecommerce-product-detail/:id",
  
  
];

// const subAdminAllowedRoutes = [
//   "/ecommerce-orders", 
//   "/return", 
//   "/ecommerce-products", 
//   "/rate-cards", 
//   "/dashboard", 
// ];

const AuthMiddleware = ({ children }) => {
  const location = useLocation();
  const userString = localStorage.getItem("user");
  let user = null;
  let userRole = null;

  if (!userString) {
    console.error("AuthMiddleware: No 'user' found in localStorage.");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    user = JSON.parse(userString);
    userRole = user?.role || user?.data?.role;
  } catch (error) {
    console.error("AuthMiddleware: Failed to parse 'user' from localStorage.", error);
    localStorage.removeItem("user");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!userRole) {
    console.error("AuthMiddleware: User role not found in 'user' object.", user);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const currentPath = location.pathname;

  if (userRole === "admin") {
    return children;
  }
  if (userRole === "sub-admin") {
    return children;
  }

  if (userRole === "staff") {
    const isAllowed = staffAllowedRoutes.some(route => currentPath.startsWith(route));
    if (isAllowed) {
      return children;
    } else {
      console.warn(`AuthMiddleware: Staff access denied for path: ${currentPath}`);
      return <Navigate to="/ecommerce-products" replace />;
    }
  }

  // if (userRole === "sub-admin") {
  //   const isAllowed = subAdminAllowedRoutes.some(route => currentPath.startsWith(route));
  //    if (isAllowed) {
  //     return children;
  //   } else {
  //      console.warn(`AuthMiddleware: Sub-admin access denied for path: ${currentPath}`);
  //      return <Navigate to="/dashboard" replace />;
  //   }
  // }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default AuthMiddleware;
